import WidgetModule from "@eisinc/Overrides/Widgets/Header/MainNavigation";

export * from "@eisinc/Overrides/Widgets/Header/MainNavigation";

export default WidgetModule;
